import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let selectedLocations = useDataValue({
    context: 'tab',
    path: 'selected.locations',
    viewPath: props.viewPath,
  })
  let changeSelectedLocations = useDataChange({
    context: 'tab',
    path: 'selected.locations',
    viewPath: props.viewPath,
  })
  let locations = useDataValue({
    context: 'locations',
    viewPath: props.viewPath,
  })

  return function onClick() {
    changeSelectedLocations(
      locations.length === selectedLocations?.length
        ? []
        : locations.map(location => location._id)
    )
  }
}
